import React from "react";

import { Props } from "./types";

function ToggleArrow({ className, styles }: Props) {
  return (
    <svg className={className} style={styles} viewBox="0 0 24 24">
      <g transform="translate(-2244 12083)">
        <rect
          rx="4"
          transform="translate(2244 -12083)"
          fill="url(#linear-gradient)"
        />
        <path
          d="M6.391,17.944,11.3,13.033a.863.863,0,0,0,0-1.224l-.816-.816a.863.863,0,0,0-1.224,0L5.777,14.47,2.3,10.989a.863.863,0,0,0-1.224,0l-.82.816a.863.863,0,0,0,0,1.224L5.163,17.94A.864.864,0,0,0,6.391,17.944Z"
          transform="translate(2250.223 -12082.313)"
          fill="#fff"
        />
        <path
          d="M6.391,17.944l3.5-3.5L11.3,13.033a.863.863,0,0,0,0-1.224l-.816-.816a.863.863,0,0,0-1.224,0L5.777,14.47,2.3,10.989a.863.863,0,0,0-1.224,0l-.82.816a.863.863,0,0,0,0,1.224L5.163,17.94A.864.864,0,0,0,6.391,17.944Z"
          transform="translate(2250.223 -12088.619)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export { ToggleArrow };
